import * as React from "react";

const KodaCareLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width={529.4}
    height={53.7}
    viewBox="0 0 529.4 53.7"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: currentColor;\n      }\n    "}</style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          className="cls-1"
          d="M37.3,27.6c2.2,0,3.2,1.3,6.8,5.1l16.5,17.6c.9,1,.2,2.6-1.1,2.6h-16.2c-.4,0-.8-.2-1.1-.5l-13.5-14.5c-2.7-2.8-4.2-3.7-6.1-3.7h-6.9c-.8,0-1.5.7-1.5,1.5v15.7c0,.8-.7,1.5-1.5,1.5H1.5c-.8,0-1.5-.7-1.5-1.5V2.3C0,1.4.7.7,1.5.7h11.1c.8,0,1.5.7,1.5,1.5v17.8c0,.8.7,1.5,1.5,1.5h7.1c2.8,0,3.9-.1,7.1-3.8L44.6,1.3c.3-.3.7-.5,1.1-.5h13.9c1.3,0,2,1.5,1.2,2.5l-17.2,20c-1.9,2.2-4,3.4-6.3,3.4v1Z"
        />
        <path
          className="cls-1"
          d="M131.9,2.3c0-.8.7-1.5,1.5-1.5h35.7c18.2,0,27.3,8.5,27.3,25.4s-9.6,26.8-27.3,26.8h-35.7c-.8,0-1.5-.7-1.5-1.5V2.3ZM169.5,39.9c8.1,0,11.2-3.7,11.2-13.5s-3.3-12.6-11.2-12.6h-22c-.8,0-1.5.7-1.5,1.5v23c0,.8.7,1.5,1.5,1.5h22Z"
        />
        <path
          className="cls-1"
          d="M200.8,23.3c0-15.4,10.4-23.3,30.9-23.3s31,7.9,31,23.3v28.1c0,.8-.7,1.5-1.5,1.5h-11.1c-.8,0-1.5-.7-1.5-1.5v-6.3c0-.8-.7-1.5-1.5-1.5h-30.5c-.8,0-1.5.7-1.5,1.5v6.3c0,.8-.7,1.5-1.5,1.5h-11.1c-.8,0-1.5-.7-1.5-1.5v-28.1ZM216.5,31.3h30.5c.8,0,1.5-.7,1.5-1.5v-4.5c0-8.9-2.3-12.3-16.5-12.3s-17.1,3.9-17.1,12.3v4.5c0,.8.7,1.5,1.5,1.5Z"
        />
        <path
          className="cls-1"
          d="M329.6,33.4c0,12.4-11.3,20.3-29.6,20.3s-30.6-10.1-30.6-26.3S281.4,0,301.2,0s28.2,7.8,28.2,20.7h-3.4c-.5-11.6-8.7-17.4-24.7-17.4s-28.2,7.5-28.2,24,8.4,23,26.8,23,26.3-6.3,26.3-16.9h3.4Z"
        />
        <path
          className="cls-1"
          d="M338.7,22.4c0-13.9,8.6-22.4,28.2-22.4s27.6,8.3,27.6,22.4v30.5h-3.7v-14.3h-48.4v14.3h-3.7v-30.5ZM342.4,35.2h48.4v-12.6c0-12.7-6.1-19.2-23.5-19.2s-24.8,6.9-24.8,19.1v12.7Z"
        />
        <path
          className="cls-1"
          d="M460.3,53.4l-6.9-15c-2.7-5.9-5.6-7.7-11.8-7.7h-29.9v22.2h-3.7V.7h37.9c11.8,0,17.8,4.6,17.8,13.3s-5.1,13.6-13.9,15.1v.6c3.2.8,5.1,3,7.5,8.3l6.8,15.3h-3.8ZM411.7,27.3h32.9c9,0,15.4-3.7,15.4-13s-4.4-10.8-15.4-10.8h-32.9v23.8Z"
        />
        <path
          className="cls-1"
          d="M484.8,26.8v-.5l-1.3-.4c-5.1-1.3-8.5-5.4-8.6-11.3,0-8.6,6.6-13.9,16.8-13.9h37.3v3.4h-37.3c-8.3,0-13.1,3.9-13.1,10.7s4.6,10,13,10h34.9v3.4h-34.8c-8.5,0-14.1,3.2-14.1,11s4.1,10.4,11.8,10.4h39.9v3.4h-40.1c-10.1,0-15.4-5.1-15.4-13.2s3.9-11.6,9.6-12.7l1.3-.2Z"
        />
      </g>
      <g>
        <path
          className="cls-1"
          d="M102.3,21.6c0,1.8-1.4-1.5-3.2-1.5s-3.4,3.1-3.3,1.3,1.6-3.2,3.4-3.2,3.2,1.6,3.2,3.4Z"
        />
        <path
          className="cls-1"
          d="M124.6,21.5c-.4-1.8-1.4-3.4-2.5-4.9,0,0-3.7-8.9-8.6-11.8C108.6,2,94.4.4,94.4.4c-3.4-.6-12.4,1.2-15.1,2.1-5.4,1.1-9,5.3-11.8,9.8-4.5,7.3-6.4,15.7-4.9,23.9.8,4.6,3.2,8.4,7.1,11.4,3.2,2.5,11,7,12.8,5.3,1.5-1.5-.4-5.8-1.6-8.6-1.7-3.8-3.5-7.6-3.2-11.2-.3-1.7,0-3.6.3-5.3,0,0,0-.2,0-.3-.2-.8-.3-1.3-1-1.7-.1,0-.3-.2-.4-.4-.5-.8-1.6-1-2.3-.4-1.8,1.5-2.8,3.7-3.6,4.7-.9,1-2.3,1.5-1.9-1.2,0,0,.4-1.2.4-1.3.8-2.9,1.2-4.9,2.6-7.6,1.4-2.6,2.3-4.2,4.2-6.4.4-.5,2.4-1,2.9-.7,1.3.3,2.2,1.4,3.1,2.3.5.5,1.1,1.1,1.5,1.7.3-.5.6-.9,1-1.3,1.6-3.4,9.8-4.5,15.5-3.2,4.9,1.1,5.2,5.1,10.6,6.8,2.7.8,7.1,1.8,8.3,1.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.4,0,.4,0,0,0,0,0,.2,0,.6.3,1.1.7,1.3,1.2,0,.3,0,.5,0,.8-2.2,4.2-1.9,9.4-5.7,11.1-4.3,2.1-8.1.1-10.7,2.4-4.5,3.8-6.3,8.6-4.8,13.8.8,3,3.9,4.2,7.1,3.2,3.6-1.1,6.9-3,9.9-5.2,3.7-2.7,5.7-6.5,6.3-10.7,0-.3,0-.7.1-1,.9-2.8,1.2-5.6,1.5-8.5.2-1.8.4-3.6,0-5.4Z"
        />
      </g>
    </g>
  </svg>
);

export default KodaCareLogo;
